import type { CallYourShot } from '@/lib/db/types';
import { isValidRoundGross } from '@/lib/scoring/round-gross';

/** Pick the pending call to auto-settle when a round is posted. */
export function pickPendingCallToSettle(
  pendingShots: CallYourShot[],
  memberId: string,
  courseId: string,
  playedAtIso?: string,
): CallYourShot | null {
  const forMember = pendingShots.filter(
    (s) => s.player_id === memberId && s.status === 'pending' && s.course_id === courseId,
  );
  if (!forMember.length) return null;

  if (playedAtIso) {
    const playedDay = playedAtIso.slice(0, 10);
    const sameDay = forMember.filter((s) => s.proposed_at.slice(0, 10) === playedDay);
    if (sameDay.length) {
      return sameDay.sort(
        (a, b) => new Date(b.proposed_at).getTime() - new Date(a.proposed_at).getTime(),
      )[0];
    }
  }

  return forMember.sort(
    (a, b) => new Date(b.proposed_at).getTime() - new Date(a.proposed_at).getTime(),
  )[0];
}

/** Minimum valid gross for settle UI / auto-settle (9-hole or 18-hole). */
export function isValidCallActualScore(score: number, holes: 'full' | 'front-9' | 'back-9' = 'full'): boolean {
  return isValidRoundGross(score, holes);
}

export function callShotSettleMessage(
  targetScore: number,
  actualScore: number,
  points: number,
): string {
  const delta = targetScore - actualScore;
  const ptsLabel = points > 0 ? `+${points} pts` : points < 0 ? `${points} pts` : '0 pts';
  if (delta > 0) {
    return `Call settled — hit ${actualScore} vs ${targetScore} (${ptsLabel})`;
  }
  if (delta < 0) {
    return `Call settled — shot ${actualScore} vs ${targetScore} (${ptsLabel})`;
  }
  return `Call settled — exact at ${actualScore} (${ptsLabel})`;
}
